<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="updateDocument">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>"{{ doc.title }}" Portal Assignment</h4>
                    <v-btn density="compact" icon="mdi-close" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col class="py-0" cols="12" sm="12">
                            <v-table>
                                <thead>
                                <tr class="text-body-1">
                                    <th></th>
                                    <th>Portal</th>
                                    <th>Is Required</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="portal in portals" :key="portal.id">
                                    <td>
                                        <v-checkbox v-model="formData['portals']" :value="portal.id"
                                                    color="primary" density="compact"/>
                                    </td>
                                    <td>{{ portal.name }}</td>
                                    <td>
                                        <v-checkbox v-model="formData['is_required']" :value="portal.id" color="primary"
                                                    density="compact"/>
                                    </td>
                                </tr>
                                </tbody>
                            </v-table>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-space-between">
                    <v-btn size="small" type="button" @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useLoadingStore} from "@/stores/loadingStore";
import {useSnackbarStore} from "@/stores/snackBarStore";

const {showSnackbar} = useSnackbarStore();
const loadingStore = useLoadingStore();
const props = defineProps({
    modelValue: Boolean,
    portals: Array,
    doc: Object,
});

onMounted(() => {
    if (props.doc?.portals?.length) {
        props.doc.portals.forEach(portal => {
            formData['portals'].push(portal.pivot.portal_id);
            if (portal.pivot.is_required) {
                formData['is_required'].push(portal.pivot.portal_id);
            }
        })
    }
})
const formData = reactive({
    is_required: [],
    portals: [],
});

const errors = ref([]);
const dialogSwitch = ref(props.modelValue);
const emits = defineEmits(['update:modelValue', 'updateDoc']);


const updateDocument = () => {
    const data = {
        portals: {}
    }
    formData.portals.forEach((id) => {
        if (id) {
            data["portals"][id] = {'is_required': formData.is_required.includes(id)};
        }
    })

    errors.value = [];
    loadingStore.showLoading('Updating...', 'Saving portal assignments. Please wait.');
    send('post', `admin/legal-documents/${props.doc.id}/portals`, data)
        .then((response) => {
            showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateDoc', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response?.data?.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response?.data?.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            showSnackbar('Something went wrong', 'error');
            document.getElementById('heading')?.scrollIntoView({behavior: 'smooth'});
        })
        .finally(() => loadingStore.hideLoading());
}

</script>
